import React, {Component} from 'react';
import Page from './layout/Page';
import {TokenizationPaymentContent} from "../../components/account/myVidaVacationsPayments/TokenizationPaymentContent";
import {SecondNav} from "../../components/layout/Navbars/header/secondNav/SecondNav";
import {Routes} from "../../config";
import {FormattedMessage} from 'react-intl';

class SuccessTokenization extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <Page class="account my-vida-vacations-payments">
            <SecondNav
                linkText={
                    <FormattedMessage id="pages.account.successPayment.back_text"/>
                }
                link={Routes.ROUTE_MY_VIDA_VACATIONS_PAYMENTS}
                showSaveBtn={false}
                border={false}
            />
            <TokenizationPaymentContent/>
        </Page>
    }
}

export {SuccessTokenization}
